import { Box, HStack } from '@fhs-legacy/universal-components';

export const ContentWrapper = Box;

export const Nutrient = HStack.withConfig({
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 1,
});
